import { motion } from "framer-motion";
import classes from "./InfoPage.module.css";
import ExampleGraph from "../../ExampleGraph/ExampleGraph";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6, ease: "easeOut" },
  }),
};

const InfoPage = () => {
  return (
    <div className={classes.page}>
      {/* Hero Section */}
      <motion.section
        className={classes.hero}
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <h1>About dothink</h1>
        <p>
          A place to explore ideas, map your thoughts, and connect with others.
          We’re building tools to help you visualize and expand your thinking in
          new ways.
        </p>
      </motion.section>

      {/* Mission Section */}
      <motion.section
        className={classes.section}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        <div className={classes.text}>
          <h2>Our Mission</h2>
          <p>
            Our mission is to make creativity collaborative, fun, and
            insightful—whether you’re brainstorming for work, study, or personal
            growth.
          </p>
        </div>
        <ExampleGraph/>
      </motion.section>

      {/* Features Section */}
      <motion.section
        className={classes.sectionAlt}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        <div className={classes.text}>
          <h2>Powerful Features</h2>
          <p>
            Visualize your thoughts with interactive mind maps, build connections
            across ideas, and share your creativity seamlessly with others.
          </p>
        </div>
        <ExampleGraph/>
      </motion.section>

      {/* Community Section */}
      <motion.section
        className={classes.section}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        <div className={classes.text}>
          <h2>Why dothink?</h2>
          <p>
            Dothink was born from a desire to tap into the curiousity within every individual. I want to ask questions, answer questions, and learn about people. I built this tool to help others do the same.
          </p>
        </div>
        <ExampleGraph/>
      </motion.section>
    </div>
  );
};

export default InfoPage;
